import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=30688271"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"
import style0 from "./cards.vue?vue&type=style&index=0&id=30688271&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30688271')) {
      api.createRecord('30688271', component.options)
    } else {
      api.reload('30688271', component.options)
    }
    module.hot.accept("./cards.vue?vue&type=template&id=30688271", function () {
      api.rerender('30688271', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/sparepartslist/assets/frontend/components/cards.vue"
export default component.exports